import React, { FC } from 'react'
import { Grid, makeStyles } from 'transfix-ui/core'
import { IAs2Certificate } from 'types/graphqlTypes'
import { SuccessIcon } from 'transfix-icons'
import { brandColors, TableCell, TableRow } from 'transfix-ui'
import { ValidityToolTip } from './ValidityToolTip'

interface IAS2CertificatesTableRowProps {
  as2Certificate?: IAs2Certificate
  onRowClick: (as2Certificate: IAs2Certificate) => void
  /**
   * @example 23
   */
  validity: number | null
}

const useAS2ConnectionConfigCertificatesTableStyles = makeStyles({
  text: {
    color: brandColors.error,
  },
  certificateId: {
    textAlign: 'center',
  },
  gridDisplay: {
    display: 'flex',
    flexBasis: '0',
  },
})

export const AS2CertificatesTableRow: FC<IAS2CertificatesTableRowProps> = ({
  as2Certificate,
  onRowClick,
  validity,
}) => {
  const classes = useAS2ConnectionConfigCertificatesTableStyles()

  if (!as2Certificate) {
    return null
  }

  return (
    <TableRow key={as2Certificate.id} onClick={() => onRowClick(as2Certificate)}>
      <TableCell className='tc'>
        <Grid
          container
          className={classes.gridDisplay}
          spacing={0}
          alignItems='center'
          justifyContent='center'>
          <Grid item>{as2Certificate?.id!}</Grid>
          <Grid item>
            <ValidityToolTip validity={validity} />
          </Grid>
        </Grid>
      </TableCell>
      <TableCell className='tc'>{as2Certificate?.createdAt}</TableCell>
      <TableCell className='tc'>
        {as2Certificate?.x509ReadError ? (
          <p className={classes.text}>Invalid certificate!Error: {as2Certificate?.x509ReadError}</p>
        ) : (
          as2Certificate?.notAfter!
        )}
      </TableCell>
      <TableCell className='tc'>
        {as2Certificate?.isActive && <SuccessIcon size='large' color='green2' />}
      </TableCell>
    </TableRow>
  )
}
